export const getBlobFromUrl = (url: string) =>
  new Promise<Blob>(async (resolve, reject) => {
    fetch(url)
      .then((resp) => resp.blob())
      .then((blob) => resolve(blob))
      .catch((err) => reject(err));
  });

export const getFileFromUrl = (
  url: string,
  fileName = "image",
  modified?: number,
) =>
  new Promise<File>(async (resolve, reject) => {
    const format = url.split(".").at(-1)!;
    const data = await getBlobFromUrl(url).catch((err) => reject(err));
    if (!data) {
      reject("No blob");
      return;
    }

    const type = `image/${format === "jpg" ? "jpeg" : format}`;

    resolve(
      new File([data], fileName + "." + format, {
        lastModified: modified ?? Date.now(),
        type: type,
      }),
    );
  });

export const updateFileBlob = (file: File, blob: Blob, modified?: number) =>
  new File([blob], file.name, { lastModified: modified ?? file.lastModified });

// TODO: somehow update this to support apng
export const isAnimated = (file: File | undefined) =>
  file?.type.toLowerCase() === "image/gif" || file?.name.endsWith(".gif");

export const isCroppable = (file: File | undefined) =>
  !isAnimated(file) && file?.type.toLowerCase() !== "image/svg+xml";
